import { env } from '@env';
import { httpUtil } from '@/framework';
import { GetCustomerBarChartResponse, GetCustomerChartRequest } from './Types';

export const getCustomerRankChart = httpUtil.createHttpRequestMeta<
    GetCustomerChartRequest,
    GetCustomerBarChartResponse
>({
    baseUrl: env.orgServer,
    path: '/customers/rank-chart',
    method: 'GET',
    authentication: 'bearer'
});
